import { render, staticRenderFns } from "./DataSearch.vue?vue&type=template&id=a1512f76&scoped=true"
import script from "./DataSearch.vue?vue&type=script&lang=js"
export * from "./DataSearch.vue?vue&type=script&lang=js"
import style0 from "./DataSearch.vue?vue&type=style&index=0&id=a1512f76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1512f76",
  null
  
)

export default component.exports